import type { ReactNode } from "react";
import { cn } from "@/lib/utils/cn";

export type PillTone = "neutral" | "brand" | "success" | "warning" | "danger";

const TONE_CLASSES: Record<PillTone, string> = {
  neutral: "bg-ink/5 text-ink-muted ring-ink/10",
  brand: "bg-brand-100 text-brand-800 ring-brand-200",
  success: "bg-success-100 text-success-800 ring-success-200",
  warning: "bg-warning-100 text-warning-800 ring-warning-200",
  danger: "bg-danger-100 text-danger-800 ring-danger-200",
};

export function StatusPill({
  tone = "neutral",
  children,
  icon,
}: {
  tone?: PillTone;
  children: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset",
        TONE_CLASSES[tone],
      )}
    >
      {icon}
      {children}
    </span>
  );
}
